import React from 'react'
import FeaturesHero from './FeaturesHero'
import FeaturesCards from './FeaturesCards'

const FeaturesPage = () => {
  return (
    <div>
        
        
        <FeaturesHero />
        <FeaturesCards />
    </div>
  )
}

export default FeaturesPage